import React, { useState, useEffect } from "react";

import "./Test.css";

function Test() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("/test") // Replace with your API endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data); // Log data for debugging
        setData(data); // Update state with API response
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <div className="about-container">
      <h1>The Teams</h1>
      <p>
        Hello! Welcome to the Korean Language Game web app! This project is a
        culmination of 4 semesters of work by Computer Science Students at the
        Georgia Institute of Technology. The Squid Team started this project in
        2022; Team KLG improved its functionality in 2023. Here is an overview
        of each of the two teams:
      </p>

      <div>
        Hello
        {data ? <pre>{JSON.stringify(data, null, 2)}</pre> : "Loading..."}
      </div>
      <br></br>
      <h2>2022 - Squid Team</h2>
      <p></p>
    </div>
  );
}

export default Test;
